<section class="modalImage">
  <div class="modalImage__close">
    <mat-icon (click)="closeModal()">close</mat-icon>
  </div>
  <ng-container *ngTemplateOutlet="showCam ? takePhoto : instructions">
  </ng-container>
</section>

<ng-template #instructions>
  <div class="modalImage__iconPhone">
    <img
      src="{{ '../../../../../assets/images/logos/phone.png' }}"
      [alt]=""
      onerror="javascript:this.src='../../../../../assets/images/logos/phone.png'"
    />
  </div>
  <div class="modalImage__title m-top-16">
    <span>Recommendations for your photography</span>
  </div>
  <div class="modalImage__instructions instructions">
    <div class="instructions__container container">
      <div class="container__label m-right-8">
        <mat-icon>image</mat-icon>
      </div>
      <div class="container__span">
        <span>The photo can be taken with a cell phone or camera.</span>
      </div>
    </div>
    <div class="instructions__container container m-top-24">
      <div class="container__label m-right-8">
        <mat-icon>stay_current_landscape</mat-icon>
      </div>
      <div class="container__span">
        <span>If taken with a cell phone, place it horizontally.</span>
      </div>
    </div>
    <div class="instructions__container container m-top-24">
      <div class="container__label m-right-8">
        <mat-icon>wb_incandescent</mat-icon>
      </div>
      <div class="container__span">
        <span>Take the photo in an illuminated place.</span>
      </div>
    </div>
    <div class="instructions__container container m-top-24">
      <div class="container__label m-right-8">
        <mat-icon>palette</mat-icon>
      </div>
      <div class="container__span">
        <span>Avoid clothing that is the same color as the background.</span>
      </div>
    </div>
    <div class="instructions__container container m-top-24">
      <div class="container__label m-right-8">
        <mat-icon>grain</mat-icon>
      </div>
      <div class="container__span">
        <span>Avoid having backgrounds with too many distractors/ colors</span>
      </div>
    </div>
    <div class="instructions__container container m-top-24">
      <div class="container__label m-right-8">
        <mat-icon>camera_front</mat-icon>
      </div>
      <div class="container__span">
        <span>Take the picture from the waist upwards.</span>
      </div>
    </div>
    <div class="instructions__container container m-top-24">
      <div class="container__label m-right-8">
        <mat-icon>tag_faces</mat-icon>
      </div>
      <div class="container__span">
        <span>Remember to smile :)</span>
      </div>
    </div>
  </div>
  <div class="modalImage__note note">
    <span class="note__text"
      >Note: Please consider that we will ask you to retake the photo if these
      requirements are not met.</span
    >
  </div>
  <div class="modalImage__buttons buttons m-top-80 m-bottom-72">
    <div *ngIf="!showCam" class="buttons__take-picture take-picture">
      <button
        mat-flat-button
        color="primary"
        class="take-picture__button"
        (click)="showCamera()"
      >
        <span>TAKE A PICTURE</span>
      </button>
    </div>
    <div *ngIf="!showCam" class="buttons__upload-photo upload-photo">
      <button
        mat-stroked-button
        class="upload-photo__button"
        (click)="openSelectImage()"
      >
        <span>UPLOAD PHOTO</span>
      </button>
      <input
        hidden
        #fileInput
        id="inputSelectImage"
        type="file"
        accept="image/*"
        (change)="showPreview($event)"
      />
    </div>
  </div>
</ng-template>
<ng-template #takePhoto>
  <div class="modalImage__webcam webcam m-top-16">
    <div class="webcam__video" *ngIf="!webcamImage"></div>
    <div class="webcam__snapshot snapshot" *ngIf="webcamImage">
      <img [src]="webcamImage.imageAsDataUrl" class="snapshot__picture" />
    </div>
  </div>
  <div class="modalImage__buttons-take-camera buttons-take-camera m-top-16">
    <button
      mat-flat-button
      class="buttons-take-camera__button"
      color="primary"
      *ngIf="!webcamImage"
      (click)="triggerSnapshot()"
    >
      <span>TAKE A PICTURE</span>
    </button>
  </div>
  <div class="modalImage__buttons-take-image buttons-take-image m-top-16">
    <button
      mat-stroked-button
      class="buttons-take-image__take-other"
      *ngIf="webcamImage"
      (click)="takeOtherPhoto()"
    >
      <span>TAKE ANOTHER</span>
    </button>
    <button
      mat-flat-button
      class="buttons-take-image__save"
      color="primary"
      *ngIf="webcamImage"
      (click)="savePhoto()"
    >
      <span>SAVE</span>
    </button>
  </div>
</ng-template>
